import * as Settings from "../../util/settings.js";
import * as Analytics from "../../analytics.js";
export const subscribe = (elmApp) => {
  elmApp.ports.saveUserSettingsToLocalStorage.subscribe((settings_) => {
    const settings = settings_;
    Settings.saveToLocalStorage(settings);
    Analytics.setOptOut(settings);
  });
};
